import { render, staticRenderFns } from "./MaterialLinkPop.vue?vue&type=template&id=c60728bc&scoped=true"
import script from "./MaterialLinkPop.vue?vue&type=script&lang=ts"
export * from "./MaterialLinkPop.vue?vue&type=script&lang=ts"
import style0 from "./MaterialLinkPop.vue?vue&type=style&index=0&id=c60728bc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60728bc",
  null
  
)

export default component.exports